import { motion } from 'framer-motion';
import ScrollReveal from './ScrollReveal';
import AnimatedText from './AnimatedText';
import SocialLinks from './SocialLinks';

const CTASection = () => {
  return (
    <section className="section-padding relative overflow-hidden">
      <div className="container-premium">
        <div className="relative max-w-4xl mx-auto text-center">
          {/* Background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
          
          <div className="relative z-10">
            <ScrollReveal>
              <p className="text-gold tracking-[0.2em] uppercase text-sm mb-6">
                Pronto a crescere?
              </p>
            </ScrollReveal>

            <AnimatedText 
              as="h2" 
              text="Il momento giusto per iniziare era ieri. Il secondo momento migliore è oggi." 
              className="font-serif text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-8 leading-loose px-4 pb-4" 
              letterByLetter={false} 
            />
            
            <ScrollReveal delay={0.3}>
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12">
                30 minuti. Nessun impegno. Solo una conversazione onesta su come 
                possiamo aiutarti a raggiungere i tuoi obiettivi.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.4}>
              <motion.a 
                href="/contatti" 
                className="btn-premium text-lg inline-flex" 
                whileHover={{ scale: 1.05 }} 
                whileTap={{ scale: 0.98 }}
              >
                <span>Prenota la Tua Call Gratuita</span>
              </motion.a>
            </ScrollReveal>

            <ScrollReveal delay={0.5}>
              <p className="text-sm text-muted-foreground mt-8">
                Risposta entro 24 ore • 100% gratuita • Zero spam
              </p>
            </ScrollReveal>

            {/* Social CTA */}
            <ScrollReveal delay={0.6}>
              <div className="mt-10 pt-8 border-t border-border/30">
                <SocialLinks variant="cta" showText />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
